export enum CourtType {
    Tingrett = 10,
    Jordskifterett = 20,
    Lagmannsrett = 30,
    Høyesterett = 40,
    Andre = 50,
}
